import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, effect, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Select, SelectChangeEvent } from 'primeng/select';
import { tap } from 'rxjs';
import { PageContainerService } from '../../../../services/page-container.service';
import { NavigationItem } from '../../../../interfaces/navigationList.interface';

@Component({
  selector: 'st-top-header-tab',
  imports: [CommonModule, Select, FormsModule, RouterModule],
  templateUrl: './top-header-tab.component.html',
  styleUrls: ['./top-header-tab.component.scss'],
})
export class TopHeaderTabComponent {
  tabData = input.required<NavigationItem>();
  active = input<boolean>(false);
  activeChild!: NavigationItem | null;
  activeDropDownMenu!: any;

  selectLastChild$ = this.pageContainerService.selectLastChild$.pipe(
    tap((child) => {
      this.activeDropDownMenu = child;
      this.cd.detectChanges();
    }),
  );

  constructor(
    readonly router: Router,
    readonly pageContainerService: PageContainerService,
    readonly cd: ChangeDetectorRef,
  ) {
    effect(() => {
      if (this.active() && this.tabData()) {
        this.getRoutePath();
      } else {
        this.activeChild = null;
      }
    });
  }

  goTo(dropdown: Select) {
    if (this.tabData().children.length) {
      dropdown.show();
    } else if (this.tabData().routeUrl.length) {
      this.router.navigate([this.tabData().routeUrl]);
    }
  }

  selectChild(ev: SelectChangeEvent) {
    const item = ev.value as NavigationItem;
    if (item.routeUrl.length) this.router.navigate([item.routeUrl]);

    let currentPath = this.pageContainerService
      .getRoutePath()
      .find((x) => x.url === item.routeUrl)?.routePath;
    if (currentPath) this.setActiveItem(currentPath);
  }

  getRoutePath() {
    let currentPath = this.pageContainerService
      .getRoutePath()
      .find((x) => x.url === this.router.url.split('?')[0])?.routePath;

    if (currentPath) this.setActiveItem(currentPath);
  }

  setActiveItem(currentPath: number[]) {
    const index = this.tabData().children.findIndex(
      (y) => y && currentPath && y.id === currentPath[2],
    );
    if (index === -1) {
      return;
    }
    this.activeChild = this.tabData().children[index];
    this.activeDropDownMenu = this.tabData().children[index];
    this.cd.detectChanges();
  }
}
